import React from "react";
import map from '../../assets/map.jpg'

export default function Demo() {
  return (
    <div className="w-full min-h-screen flex items-center justify-center p-6 md:p-12">
      <div className="max-w-7xl w-full">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          
          {/* Left Section - Enhanced */}
          <div className="lg:w-1/2 w-full flex flex-col gap-8">
            <div className="flex flex-col gap-4" data-aos="fade-left">
            
              
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Building The Future Of
                <span className="bg-gradient-to-r from-blue-600 to-blue-600 bg-clip-text text-transparent">
                  {" "}European Business
                </span>
              </h1>
              
              <p className="text-gray-700 text-xl leading-relaxed ">
                At All Global Consultancy Service, we're pioneering the next generation of cross-border business solutions. 
                We empower organizations with cutting-edge technology, sustainable practices, and seamless 
                connectivity to unlock unprecedented growth across Europe.
              </p>
            </div>


            
          </div>

          {/* Right Section - Enhanced Map */}
          <div className="lg:w-1/2 w-full flex justify-center" data-aos="fade-right">
            <div className="relative">
              {/* Floating elements */}
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
              
              {/* Map Container with enhanced styling */}
              <div className="relative z-10">
                <img
                  src={map}
                  alt="Europe Map showing Vise Company's reach across European countries"
                  className="max-w-full h-auto lg:h-[400px] rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500 border-8 border-white"
                />
                
                {/* Animated dots on map */}
                <div className="absolute top-1/4 left-1/4 w-4 h-4 bg-blue-600 rounded-full animate-ping"></div>
                <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-blue-600 rounded-full animate-ping delay-500"></div>
                <div className="absolute bottom-1/3 left-1/3 w-3 h-3 bg-blue-500 rounded-full animate-ping delay-700"></div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}